export const idToUrl = (id: string) =>
  `https://${id}.execute-api.eu-west-2.amazonaws.com/v1/`

export const JafToken = 'jaf-jwt'
export const TS_ApiUrl = idToUrl('v2j9avlfpb')
export const PyAuth_ApiUrl = idToUrl('khzh1zwjy0')
export const PyAdminQuiz_ApiUrl = idToUrl('2zxurp8ed1')
export const PyUserQuiz_ApiUrl = idToUrl('iqqc3egl51')
export const Golang_ApiUrl = idToUrl('xod4oxfto7')
export const BaseSpotifyApiUrl = 'https://accounts.spotify.com/'
export const SpotifyClientId = '678f8fa942f640deaad0fa4f8005c98d'
export const SpotifyScopes =
  'user-read-private user-read-email user-top-read user-read-recently-played'
export const AdminSpotifyId = 'xnmacgqaaa6a1xi7uy2k1fe7w'

export const GREEN_COLOUR = '#1db954'
export const YELLOW_COLOUR = '#fbe719'
export const ORANGE_COLOUR = '#f59b23'
export const RED_COLOUR = '#eb1e32'
